module.exports = __webpack_public_path__ + "img/vera-kondrateva.98661a6a.jpg";